var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJe = function SvgJe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m21.52 19.307-7.306-7.306 7.307-7.307a12.129 12.129 0 0 0-2.214-2.214l-7.306 7.307L4.694 2.48a12.113 12.113 0 0 0-2.213 2.214L9.787 12 2.48 19.308a12.122 12.122 0 0 0 2.214 2.214l7.307-7.307 7.306 7.307a12.122 12.122 0 0 0 2.214-2.214Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M9.913 3.653 12 4.175l2.087-.522V1.879l-.835.417L12 1.044l-1.252 1.252-.835-.417v1.774Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M9.913 3.653v1.304C9.913 6.555 12 7.044 12 7.044s2.087-.49 2.087-2.087V3.653H9.913Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgJe;